export const spacingUnit = 1.5
export const spacingMin = spacingUnit / 6
export const spacingTiny = spacingUnit / 3
export const spacingSmall = spacingUnit / 2
export const spacingMedium = spacingUnit / 1.5
export const spacingMediumDouble = spacingMedium * 2
export const spacingBig = spacingUnit * 2
export const spacingLarge = spacingUnit * 4

export const minWidthSupported = 320

const breakpointMobile = 432
const breakpointMobileLarge = 544
const breakpointTablet = 767
const breakpointDesktop = 992
const breakpointDesktopLarge = 1200

export const widthMainContent = 768

export const maxWidthMobile = `${breakpointMobile}px`
export const minWidthMobileLarge = `${breakpointMobile + 1}px`
export const maxWidthMobileLarge = `${breakpointMobileLarge}px`
export const minWidthTablet = `${breakpointMobileLarge + 1}px`
export const maxWidthTablet = `${breakpointTablet}px`
export const minWidthDesktop = `${breakpointTablet + 1}px`
export const maxWidthDesktop = `${breakpointDesktop}px`
export const minWidthDesktopLarge = `${breakpointDesktop + 1}px`
export const maxWidthDesktopLarge = `${breakpointDesktopLarge}px`
